import { AllSARConstant } from "src/app/features/allsar/constants/all-sar.constant"

export const ALLSARABUExcelHeaders = [
  AllSARConstant.SARID,
  AllSARConstant.BUUNIT,
  AllSARConstant.TITLE,
  AllSARConstant.ACTIONNO,
  AllSARConstant.ACTION,
  AllSARConstant.SUPPLIER,
  AllSARConstant.SUPPLIERNO,
  AllSARConstant.PRIORITY,
  AllSARConstant.BRANCH,
  AllSARConstant.OWNER,
  AllSARConstant.CREATEDON,
  AllSARConstant.DESCRIPTION,
  AllSARConstant.UOM,
  AllSARConstant.MRP,
  AllSARConstant.LINENO,
  AllSARConstant.MATERIALNO,
  AllSARConstant.STATUS,
  AllSARConstant.LASTMODIFIEDBY,
  AllSARConstant.MODIFIEDBY,
  AllSARConstant.ASSIGNEDTO,
  AllSARConstant.UNITUSAGE,
  AllSARConstant.TOTALMIN,
  AllSARConstant.TOTALMAX,
  AllSARConstant.ANNUALUSAGE,
  AllSARConstant.CHANGEINVALUE,
  AllSARConstant.TOTALVALUE,
  AllSARConstant.QACODE,
  AllSARConstant.THREED,
  AllSARConstant.EQUIPMENTCRITICALITY
];

export const ALLSARCNAEPBUExcelHeaders = [
  AllSARConstant.SARID,
  AllSARConstant.BUUNIT,
  AllSARConstant.TITLE,
  AllSARConstant.ACTIONNO,
  AllSARConstant.ACTION,
  AllSARConstant.PRIORITY,
  AllSARConstant.OWNER,
  AllSARConstant.CREATEDON,
  AllSARConstant.DESCRIPTION,
  AllSARConstant.MANUFACTURE,
  AllSARConstant.MANUFACTURERPARTNUMBER,
  AllSARConstant.UOM,
  AllSARConstant.SEGMENT,
  AllSARConstant.MRP,
  AllSARConstant.LINENO,
  AllSARConstant.MATERIALNO,
  AllSARConstant.MATERIALGROUPCODE,
  AllSARConstant.SHORTDESCRIPTION,
  AllSARConstant.ENRICHEDDESCRIPTION,
  AllSARConstant.DATACHANGETYPE,
  AllSARConstant.NEWDATA,
  AllSARConstant.PLANT,
  AllSARConstant.PLANTDF,
  AllSARConstant.STORAGELOCATION,
  AllSARConstant.STORAGELOCATIONDF,
  AllSARConstant.RECOMMENDEDMIN,
  AllSARConstant.RECOMMENDEDMAX,
  AllSARConstant.VALUATIONTYPE,
  AllSARConstant.VALUATIONTYPEDF,
  AllSARConstant.BIN,
  AllSARConstant.STATUS,
  AllSARConstant.SUBMITTEDBY,
  AllSARConstant.SUBMITTEDON,
  AllSARConstant.ASSIGNEDTO,
  AllSARConstant.ASSIGNEDGROUP,
  AllSARConstant.APPROVEDBY,
  AllSARConstant.APPROVEDON,
  AllSARConstant.CLOSEDBY,
  AllSARConstant.CLOSEDON
];
